import { tunnelCells } from './signature';
import type { HeroDefinition } from '../types';

/** Bristle Roll — clear one row. The tapped tile is where Pip rolls in. */
export const pip: HeroDefinition = {
  id: 'pip',
  name: 'Pip',
  species: 'hedgehog',
  classId: 'guardian',
  powerName: 'Bristle Roll',
  color: 'acorn',
  description: 'Clears a whole row. Tap the tile he rolls into.',
  target: 'row',
  paw: 'cc_hero_pip_paw@1x.png',
  apply(state, _player, target) {
    const r = target?.r ?? 0;
    return { clear: tunnelCells(state, 'row', r), convert: [] };
  },
};
